
import {useStore} from "@/store";
import {useRouter, useRoute} from "vue-router";
import {defineComponent, reactive, ComputedRef, computed, toRefs, watch} from "vue";

interface State {
    tocOnlyShowFlaw: any;
    checkItemList: any;
    normalList: any;
    unusualList: any;
    defaultList: any;
    onlyFlawList: any;
    unusualObj: any;
    normalObj: any;
    photoList: any;
}
export default defineComponent({
    name: 'checkContent',
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    setup(props) {
        let state: State = reactive({
            tocOnlyShowFlaw: false,
            checkItemList: [],
            normalList: [],
            unusualList: [],
            defaultList: [],
            onlyFlawList: [],
            unusualObj: {},
            normalObj: {},
            photoList: [],
        })
        const router = useRouter();
        let store = useStore();
        let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
        const {renderData} = toRefs(props);
        const checkItemList  = renderData.value.checkItemList;
        checkItemList.forEach(item => {
            if (item.unusual) {
                state.unusualList.push(item);
            } else {
                state.normalList.push(item);
            }
        })
        let {defectCount,limitedCount,normalCount,noSuchCount } = renderData.value;
        state.normalObj = {
            title: 'Нормальные',
            code: 'normal',
            hide: false,
            defectCount,
            limitedCount,
            normalCount,
            noSuchCount,
            itemLists: state.normalList,
            photoList: renderData.value.normalPhotoList
        };
        state.unusualObj = {
            title: 'Аномальные',
            code: 'unusual',
            hide: false,
            defectCount,
            limitedCount,
            normalCount,
            noSuchCount,
            itemLists: state.unusualList,
            photoList: renderData.value.defectPhotoList
        };
        if (defectCount > 0) {
            state.defaultList = [state.unusualObj, state.normalObj];
        } else {
            state.defaultList = [state.normalObj];
        }
        state.onlyFlawList = [state.unusualObj]
        state.checkItemList = state.defaultList;
        watch(tocOnlyShowFlawS, (data: any) => {
            state.tocOnlyShowFlaw = data;
            if (data) {
                state.checkItemList = state.onlyFlawList;
            } else {
                state.checkItemList = state.defaultList;
            }
        }, {immediate: true})
        
        let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
        
        watch(reportData, (data: any) => {
            const {defectPhotoList} = data
            state.photoList = defectPhotoList;
        },{immediate: true})
        
        return {
            state,
            router,
            store,
        }
    },
    methods: {
        changeItemCheckType(item) {
            item.hidden = !item.hidden;
        },
        getNormalTitles(item) {
            let titles: any = [];
            let nomalObj = {
                name: 'Нормальные',
                icon: 'fullreport-green',
                count: item.normalCount || 0
            };
            titles.push(nomalObj);
            if (item.noSuchCount > 0) {
                let positionObj = {
                    name: 'Компонент отсутствует',
                    icon: 'fullreport-nopart',
                    count: item.noSuchCount
                };
                titles.push(positionObj);
            }
            if (item.limitedCount > 0) {
                let constrainedObj = {
                    name: 'Проверка невозможна',
                    icon: 'fullreport-limited',
                    count: item.limitedCount
                };
                titles.push(constrainedObj);
            }
            return titles;
        },
        goToImgView(item) {
            // console.log('goToImgView'+JSON.stringify(item) + 'parentIndex' + parentIndex + 'sonIndex' + sonIndex);
            if (item.itemDesc === 'Компонент отсутствует') {
                return;
            }
            let photo = item.photoList && item.photoList[0];
            let currentIndex = 0;
            for (let i =0;i<this.state.photoList.length;i++){
                let item: any = this.state.photoList[i];
                if (item.photoIdStr === photo.photoIdStr) {
                    currentIndex = i;
                    break;
                }
            }
            this.store.dispatch('savePageScrollTop', window.scrollY);
            this.router.push({
                path:'/promiseFramePhotoListRu',
                query: {
                    photoIndex: currentIndex,
                    group: 'defect' ,
                }
            })
            
        },
    }
})
